import { render, staticRenderFns } from "./ReportesProyectos.vue?vue&type=template&id=44beeba6&scoped=true"
import script from "./ReportesProyectos.vue?vue&type=script&lang=js"
export * from "./ReportesProyectos.vue?vue&type=script&lang=js"
import style0 from "./ReportesProyectos.vue?vue&type=style&index=0&id=44beeba6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44beeba6",
  null
  
)

export default component.exports